import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import { IncentiveOfferStatus } from 'modules/incentivesMarket/types';
import incentiveOfferStatus from '../constants/incentiveOfferStatus';

export enum IncentiveOfferStatusBadgeVariant {
  BADGE = 'badge', // eslint-disable-line no-unused-vars
  TEXT = 'text', // eslint-disable-line no-unused-vars
}

type IncentiveOfferStatusBadgeProps = {
  status: IncentiveOfferStatus;
  variant?: IncentiveOfferStatusBadgeVariant;
};

const IncentiveOfferStatusBadge: FC<IncentiveOfferStatusBadgeProps> = ({
  status,
  variant = IncentiveOfferStatusBadgeVariant.BADGE,
}) => {
  const { t } = useTranslate();

  const currentStatus = incentiveOfferStatus[status];

  const badgeClasses = {
    [IncentiveOfferStatusBadgeVariant.BADGE]: `badge ${currentStatus.badge} fs-11px mx-1`,
    [IncentiveOfferStatusBadgeVariant.TEXT]: `${currentStatus.style} fw-medium d-inline`,
  };

  const iconClasses = {
    [IncentiveOfferStatusBadgeVariant.BADGE]: `icon ni ${currentStatus.icon} lh-18px`,
    [IncentiveOfferStatusBadgeVariant.TEXT]: `icon ni ${currentStatus.icon} mr-1`,
  };

  return (
    <span className={badgeClasses[variant]}>
      <em className={iconClasses[variant]} />
      <span>{t(currentStatus.label)}</span>
    </span>
  );
};

export default IncentiveOfferStatusBadge;
